import React from "react";
import { Footer } from "../../components/Footer";
import { Nav } from "../../components/Nav";
import "./style.css";
import { ContactForm } from "../../components/ContactForm";

export const ClientsPage = () => {
    return (
        <div className="main talent" id="talent">
            <div className="overlap">
            <div className="content">
                <div className="element hero bg-white">
                    <div className="frame">
                        <p className="heading color-black">
                        Comprehensive Workforce Solutions for
                        Modern Businesses
                        </p>
                        <p className="heading2 color-black">
                            At recruit22, we provide end-to-end talent acquisition and staffing 
                            services designed to meet the dynamic needs of today's 
                            organizations. Our holistic approach ensures you find the right talent at the right time.
                        </p>
                    </div>
                    <div className="image">
                        <div className="group">
                            <div className="rectangle" />
                        </div>
                    </div>
                </div>
                <div className="element bg-gray">
                    <div className="frame">
                        <p className="heading color-black">
                        Our Service Offerings
                        </p>
                        <div className="group-service image-centered" />
                        <div className="service-offerings">
                            <div className="block-service">
                                <div className="service-title">
                                    <div className="block-title color-black">
                                        Executive Search Services
                                    </div>
                                </div>
                                <div className="service-text">
                                    <div className="block-text color-black">
                                        <p>Precision talent acquisition for leadership roles:</p>
                                        <ul className="service-ul">
                                            <li>Confidential and discreet executive searches</li>
                                            <li>Strategic leadership placement</li>
                                            <li>Comprehensive candidate assessment</li>
                                            <li>Global talent mapping</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        <div className="block-service">
                            <div className="service-title">
                                <div className="block-title color-black">
                                    IT Staffing Solutions
                                </div>
                            </div>
                            <div className="service-text">
                                <div className="right-block color-black">
                                    <div className="block-text color-black">
                                        <p>Specialized technology talent acquisition for full-time and contract roles:</p>
                                        <ul className="service-ul">
                                            <li>Full-Time Placement:
                                                <ul className="service-ul">
                                                    <li>Permanent IT professionals across all technology domains</li>
                                                    <li>Rigorous technical and cultural screening tailored to our client needs</li>
                                                    <li>Expertise in emerging and established technologies</li>
                                                </ul>
                                            </li>
                                        </ul>
                                        <ul className="service-ul">  
                                        <li>
                                        Contract Staffing:
                                        <ul className="service-ul">  
                                            <li>
                                                Flexible IT resource allocation
                                            </li>
                                            <li>
                                                Short-term and project-based tech talent
                                            </li>
                                            <li>
                                                Quick mobilization of specialized skills
                                            </li>
                                            <li>
                                            Comprehensive contractor management
                                            </li>
                                        </ul>
                                        </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="block-service">
                            <div className="service-title">
                                <div className="block-title color-black">
                                    <p>Staff Augmentation Services </p>
                                </div>
                            </div>
                            <div className="service-text">
                                <div className="block-text color-black">
                                    <p>Flexible workforce solutions tailored to your unique needs: </p>
                                    <ul className="service-ul">
                                        <li>Rapid scaling of your workforce</li>
                                        <li>
                                        Access to specialized IT and technical expertise 
                                        </li>
                                        <li>
                                        Flexible engagement models 
                                        </li>
                                        <li>
                                        Reduced recruitment and overhead costs 
                                        </li>
                                        <li>
                                        Instant productivity with pre-vetted professionals 
                                        </li>
                                        <li>
                                        Customized team composition for specific project requirements 
                                        </li>
                                        <li>
                                        Scalable solutions for short-term and long-term projects 
                                        </li>
                                    </ul>
                                    <p>Team Design and Assembly: </p>
                                    <ul className="service-ul">
                                        <li>Comprehensive project requirement analysis </li>
                                        <li>Strategic team composition </li>
                                        <li>Skill-based talent matching </li>
                                        <li>Cross-functional team development </li>
                                        <li>Performance-optimized team structures </li>
                                        <li>Tailored solutions for: 
                                            <ul className="service-ul">
                                                <li>Software development </li>
                                                <li>Digital transformation </li>
                                                <li>Technology implementation </li>
                                                <li>Innovation initiatives </li>
                                                <li>Complex technical projects </li>
                                            </ul>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                            
                        </div>
                        <div className="block-service">
                            <div className="service-title">
                                <div className="block-title color-black">
                                    <p>Hiring Advisory and Consulting </p>
                                </div>
                            </div>
                            <div className="service-text">
                            <div className="block-text color-black">
                                <p>Strategic workforce planning and recruitment optimization:</p>
                                <ul className="service-ul">
                                    <li>Detailed workforce strategy development </li>
                                    <li>Talent acquisition process optimization </li>
                                    <li>Market insights and compensation benchmarking </li>
                                    <li>Recruitment technology and tool recommendations </li>
                                    <li>Diversity and inclusion hiring strategies </li>
                                    <li>Talent retention and development planning </li>
                                </ul>
                            </div>
                            </div>
                            
                        </div>
                        </div>
                        
                    </div>
                </div>
                <div className="element bg-dark-blue">
                    <div className="frame">
                        
                        <p className="heading color-white">
                        Our Distinctive Approach
                        </p>
                        <div className="group-approcah image-centered" />
                        <div className="block-right ">
                            <div className="block-title color-white contact-frame">
                                
                                <p>Tailored Solutions: <br />
                                Custom strategies for each client.</p>
                                <p>
                                End-to-End Support: <br />
                                From initial consultation to final placement.
                                </p>
                                <p>
                                Proven Methodology: <br />
                                Rigorous candidate evaluation.
                                </p>
                                <p>
                                Confidentiality Assured: <br />
                                Protecting your organizational interests.
                                </p>
                                <p>
                                Technology-Driven:  <br />
                                Leveraging advanced recruitment technologies.
                                </p>
                                </div>
                        </div>
                        
                    </div>
                </div>
                <div className="element bg-gray">
                    <div className="frame">
                        <p className="heading color-black">
                        Why Partner With Us
                        </p>
                        <div className="group-partner image-centered" />
                        <div className="block-right">
                            <div className="block-title color-black contact-frame">
                            <p>Extensive professional network.</p>

                            <p>Deep industry expertise.</p>

                            <p>Proven track record of successful placements.</p>

                            <p>Commitment to client satisfaction.</p>

                            <p>Adaptable and responsive service.</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="element bg-white" id="contactForm">
                    <div className="frame">
                        <div className="block-right">
                            <div className="contact-frame">
                                <div className="block-title color-black">
                                Ready to Transform Your Workforce?
                                </div>
                                <div className="block-text color-black">
                                Unlock your organization's potential through strategic talent acquisition. Contact us today to discuss your staffing and recruitment needs.
                                </div>
                                <ContactForm />
                            </div>

                        </div>
                    </div>
                </div>
                <Footer
                    footer="default"
                />
            </div>
            <Nav className="nav-instance" nav="default" />
            </div>
        </div>
    );
};
